import React from 'react';
import HelmetLib from 'react-helmet';

type Head = {
  title: string;
  favicon: string;
};

export default function Helmet({ title, favicon }: Head) {
  return (
    <HelmetLib>
      <title>{title}</title>
      <link rel="shortcut icon" href={favicon} />
    </HelmetLib>
  );
}
